<template>
  <div>
    <b-overlay :show="loading">

      <div>

        <div class="row no-margin pt-5">
            <div class="ibox col-md-12 payrun-wizard-breadcrumb mt-2">
                <div class="ibox-title dashboard_title px-0 py-4"><h4 class="atlhr-dashboard-title pt-0 my-2">Penalty Wizard<span><a v-bind:href="$api_url+'/company/dashboard'">Dashboard </a>/ Leave & Attendance / Penalty </span></h4></div>
            </div>
        </div>

        <div class="col-md-12 bg-white shadow-lg payrun-wizard-container ibox pb-5">


          <form-wizard ref="wizard" color="#0060C9" @on-complete="onComplete">
            <template slot="step" slot-scope="props">
                <wizard-step :tab="props.tab"
                :transition="props.transition"
                :key="props.tab.title"
                :index="props.index">
                </wizard-step>
            </template>
            <h2 class="py-2 mt-3 mb-4" slot="title">Process Flow</h2>
            <tab-content title="Select Month and Fiscal Year" :before-change="changeMessageflagBefore">

                <div class="clearfix row form-btn-container rounded mb-4">
                    <div class="col-md-4 pl-0"><b-button  class="custom-wizard-btn"  :href="$api_url+'/leave-attendance/penalty/'"><b-icon icon="chevron-left" rotate="0" class="mr-2" scale="1"></b-icon> Back to Penalty Run List</b-button></div>
                    <div class="col-md-4 text-center custom-wizard-title">Select Month and Fiscal Year</div>
                    <div class="col-md-4 pr-0 text-right"><b-button type="button" variant="primary" @click="nextWizardStep()" :disabled="isFutureMonth">Next <b-icon icon="chevron-right" rotate="0" class="mt-n1" scale="1"></b-icon></b-button></div>
                </div>
                <h3 class="my-5 text-center d-inline-block w-100">Please choose your desired period</h3>

                <div class="row no-margin justify-content-center">
                    <div class="col-md-4 float-left px-3">
                        <div class="form-group">
                            <label for="name" class="col-form-label">Month</label>
                            <b-form-select
                                @change="validateDate"
                                v-model="month"
                                :options="$month_options ? $month_options : monthOptions"
                                name="selected_month"
                            ></b-form-select>
                        </div>
                    </div>
                    <div class="col-md-4 float-left px-3">
                        <div class="form-group">
                            <label for="name" class="col-form-label">Year</label>
                            <b-form-select
                                @change="validateDate"
                                v-model="year"
                                :options="$year_options ? $year_options : yearOptions"
                                name="selected_year"
                            ></b-form-select>
                        </div>
                    </div>
                </div>
            </tab-content>


            <tab-content title="Select Date Range" :before-change="beforeChangeStep3">

              <div class="clearfix row form-btn-container rounded mb-4">
                  <div class="col-md-4 pl-0"><b-button class="custom-wizard-btn" type="button" variant="primary"  @click="moveBack()"><b-icon icon="chevron-left" rotate="0" class="mt-n1" scale="1"></b-icon> Back</b-button></div>
                  <div class="col-md-4 text-center custom-wizard-title">Date Range</div>
                  <div class="col-md-4 pr-0 text-right"><b-button type="button" variant="primary" @click="generatePenalty" :disabled="loading || (date_range_mode == 1 && (range_from_date == '' || range_to_date == ''))">Generate Penalty <b-icon icon="chevron-right" rotate="0" class="mt-n1" scale="1"></b-icon></b-button></div>
              </div>

              <b-alert show v-for="(error, index) in errors" :key="index" variant="danger">
                {{ error }}
              </b-alert>

              <div class="card border-0 no-shadow">
                  <div class="card-body py-0">
                      <div class="deprtment-top-block">
                          <h5 class="my-5 text-center d-inline-block w-100">Do You Want to Select a Date Range?</h5>
                      </div>
                  </div>
              </div>

              <div v-if="date_range_mode == 0" class="d-flex flex-row justify-content-center align-items-center">
                <b-button @click="date_range_mode = 1" class="mr-2">Yes</b-button>
                <b-button @click="generatePenalty" class="ml-2">No, Generate Penalty</b-button>
              </div>

              <div v-else>
                <b-row class="d-flex justify-content-center align-items-center">
                  <b-col cols="12" md="8" lg="6">
                    <b-form-row v-if="date_range_mode == 1" class="justify-content-center mb-3">
                      <b-col cols="6">
                        <b-form-group
                            id="range_from_date-group"
                            label="From Date"
                            label-for="range_from_date"
                            class="required-field"
                        >
                          <b-input-group>
                            <b-form-input
                                id="range_from_date"
                                name="range_from_date"
                                v-model="range_from_date"
                                v-validate="'required|date_format:yyyy-MM-dd'"
                                type="text"
                                placeholder="YYYY-MM-DD"
                                autocomplete="off"
                                :state="validateState('range_from_date')"
                                aria-describedby="range_from_date-feedback"
                                data-vv-as="From Date"
                            />
                            <b-input-group-append>
                              <b-form-datepicker
                                  :min="minDate" :max="maxDate"
                                  id="range_from_date_picker"
                                  button-only
                                  right
                                  locale="en-US"
                                  v-model="range_from_date"
                                  @input="range_to_date = range_from_date"
                              />
                            </b-input-group-append>
                            <b-form-invalid-feedback id="range_from_date-feedback">
                              {{ veeErrors.first('range_from_date') }}
                            </b-form-invalid-feedback>
                          </b-input-group>
                        </b-form-group>
                      </b-col>

                      <b-col cols="6">
                        <b-form-group
                            id="range_to_date-group"
                            label="To Date"
                            label-for="range_to_date"
                            class="required-field"
                        >
                          <b-input-group>
                            <b-form-input
                                id="range_to_date"
                                name="range_to_date"
                                v-model="range_to_date"
                                v-validate="'required|date_format:yyyy-MM-dd'"
                                type="text"
                                placeholder="YYYY-MM-DD"
                                autocomplete="off"
                                :state="validateState('range_to_date')"
                                aria-describedby="range_to_date-feedback"
                                data-vv-as="To Date"
                            />
                            <b-input-group-append>
                              <b-form-datepicker
                                  id="range_to_date_picker"
                                  button-only
                                  right
                                  locale="en-US"
                                  :min="minDate" :max="maxDate"
                                  v-model="range_to_date"
                              />
                            </b-input-group-append>
                            <b-form-invalid-feedback id="range_to_date-feedback">
                              {{ veeErrors.first('range_to_date') }}
                            </b-form-invalid-feedback>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12" class="text-center">
                    <b-button @click="date_range_mode=0; ">Cancel</b-button>
                    <b-button @click="generatePenalty" :disabled="loading || (date_range_mode == 1 && (range_from_date == '' || range_to_date == ''))">
                      Generate Penalty
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </tab-content>

            <tab-content title="Summary" :before-change="changeMessageflagBefore">

                <div class="clearfix row form-btn-container rounded mb-4">
                    <div class="col-md-4 pl-0"></div>
                    <div class="col-md-4 text-center custom-wizard-title">Summary</div>
                    <div class="col-md-4 pl-0 text-right"><b-button  class="custom-wizard-btn"  :href="$api_url+'/leave-attendance/penalty/'"><b-icon icon="chevron-left" rotate="0" class="mr-2" scale="1"></b-icon> Back to Penalty Run List</b-button></div>

                </div>

              <div class="bg-wash mb-3 px-3 py-4">
                <b-row class="text-center">
                  <b-col>
                    <div class="text-muted small">Total Employees</div>
                    <div class="h4 font-weight-bold">{{ penaltiesAggregate.employees }}</div>
                  </b-col>

                  <b-col>
                    <div class="text-muted small">Total Penalty Entries</div>
                    <div class="h4 font-weight-bold">{{ penaltiesAggregate.entries }}</div>
                  </b-col>

                  <b-col>
                    <div class="text-muted small">Deduction Days</div>
                    <div class="h4 font-weight-bold text-danger">{{ formatDeductNumber(penaltiesAggregate.amount) }}</div>
                  </b-col>

                  <b-col>
                    <div class="text-muted small">Leave Deduct</div>
                    <div class="h4 font-weight-bold text-danger">{{ formatDeductNumber(penaltiesAggregate.leave_deduct) }}</div>
                  </b-col>

                  <b-col>
                    <div class="text-muted small">Salary Deduct</div>
                    <div class="h4 font-weight-bold text-danger">{{ formatDeductNumber(penaltiesAggregate.salary_deduct) }}</div>
                  </b-col>
                </b-row>
            </div>

              <div class="table-responsive employee-table-wrapper mt-3">
                <table class="employee-list-table table table-hover dataTable table-overflow table-sticky">
                  <thead class="table-head">
                  <tr>
                    <th>Employee ID</th>
                    <th>Employee Name</th>
                    <th>From</th>
                    <th>To</th>
                    <th>Deduction Days</th>
                    <th>Leave Deduct</th>
                    <th>Leave Category</th>
                    <th>Salary Deduct (Days)</th>
                    <th>Actions</th>
                  </tr>
                  </thead>
                  <tbody>
                  <template v-for="(row, index) in finalizedPenalties">
                    <tr :key="'final-' + row.id" class="hover-bg table-row border-bottom mx-2 cursor-pointer">
                      <td @click="togglePenaltySummary(row)">
                        <i class="fas" :class="isPenaltySummaryOpen(row) ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                        {{ row.employee_code }}
                      </td>
                      <td @click="togglePenaltySummary(row)">{{ row.name }}</td>
                      <td @click="togglePenaltySummary(row)">{{ row.attendance_from }}</td>
                      <td @click="togglePenaltySummary(row)">{{ row.attendance_to }}</td>
                      <td @click="togglePenaltySummary(row)">{{ formatDeductNumber(row.amount) }}</td>
                      <td @click="togglePenaltySummary(row)">{{ formatDeductNumber(row.leave_deduct) }}</td>
                      <td @click="togglePenaltySummary(row)">{{ row.leave_type }}</td>
                      <td @click="togglePenaltySummary(row)">{{ row.salary_deduct ? formatDeductNumber(row.salary_deduct) : '-' }}</td>
                      <td class="text-right">
                        <div class="action">
                            <b-button-toolbar class="float-right position-relative">
                            <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                            <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                <b-button-group class="">
                                <b-button class="border-0 rounded py-0" variant="outline-secondary" title="Edit Shift" @click="viewPenalty(row)">
                                    <b-icon icon="pencil-fill" aria-hidden="true"></b-icon> Preview
                                </b-button>
                                </b-button-group>
                            </div>
                            </b-button-toolbar>
                        </div>
                      </td>
                    </tr>

                    <tr v-if="isPenaltySummaryOpen(row)" :key="'summary-' + row.id">
                      <td colspan="11" class="p-0">
                        <b-card class="bg-light">
                          <h6 class="mb-3 font-weight-bold">Penalty Summary Breakdown</h6>

                          <b-row class="text-center">
                            <b-col>
                              <div class="text-muted small">Penalty Rows</div>
                              <div class="h5 font-weight-bold">
                                {{ getPenaltySummary(row).total_penalty_rows }}
                              </div>
                            </b-col>

                            <b-col>
                              <div class="text-muted small">Absent Count</div>
                              <div class="h5 font-weight-bold text-danger">
                                {{ getPenaltySummary(row).absent_count }}
                              </div>
                            </b-col>

                            <b-col>
                              <div class="text-muted small">Late Count</div>
                              <div class="h5 font-weight-bold text-warning">
                                {{ getPenaltySummary(row).late_count }}
                              </div>
                            </b-col>

                            <b-col>
                              <div class="text-muted small">Early Out Count</div>
                              <div class="h5 font-weight-bold text-info">
                                {{ getPenaltySummary(row).early_count }}
                              </div>
                            </b-col>

                            <b-col>
                              <div class="text-muted small">Incomplete Count</div>
                              <div class="h5 font-weight-bold text-info">
                                {{ getPenaltySummary(row).incomplete_count }}
                              </div>
                            </b-col>

                            <b-col>
                              <div class="text-muted small">Incomplete Hours</div>
                              <div class="h5 font-weight-bold text-info">
                                {{ getPenaltySummary(row).incomplete_hours }}
                              </div>
                            </b-col>
                          </b-row>
                        </b-card>
                      </td>
                    </tr>
                  </template>

                  <tr v-if="finalizedPenalties.length == 0">
                    <td colspan="10" class="text-center text-muted py-3">No penalty records for this period.</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div class="d-flex flex-wrap mt-3">
              </div>
            </tab-content>
          </form-wizard>
        </div>
    </div>

      <b-modal id="penalty-details-modal" size="xxl" title="Penalty Details" hide-footer>
        <roster-penalty-details :can_edit="false" :row="selectedPenaltyRow"></roster-penalty-details>
      </b-modal>
      <b-modal id="settle-modal-penalty" title="Penalty Run" hide-footer>
        <p class="my-4 pb-4">Do you want to generate new penalty report for individual employees or use the existing generation?</p>
        <b-row>
          <b-col cols="6" md="6" class="d-flex flex-row align-items-end flex-wrap mb-2">
            <b-button @click="goToWizardStep(1)" class="mb-2 w-100" variant="primary" :disabled="loading">Go Back</b-button>
          </b-col>

          <b-col cols="6" md="6" class="d-flex flex-row align-items-end flex-wrap mb-2">
            <b-button @click="generatePenalty" class="mb-2 w-100" variant="success" :disabled="loading">Run Penalty</b-button>
          </b-col>
        </b-row>
      </b-modal>
    </b-overlay>
  </div>
</template>

<script>
import moment from "moment";
import { FormWizard, TabContent, WizardStep } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
  components: { FormWizard, TabContent, WizardStep },

  data() {
    return {
      errors: [],
      expandedPenaltyRows: {},
      penaltySummaryMap: {},
      date_range_mode: 0,
      range_from_date: "",
      range_to_date: "",
      loading: false,
      currentStep: 0,
      maxUnlockedStep: 1,
      penalties: [],
      penaltyDetails: [],
      selectedDetailIds: [],
      selectAllDetails: false,
      selectedPenaltyId: null,
      selectedPenaltyIds: [],
      selectAllPenalties: false,
      selectedPenaltyRow: null,
      payrun_date: '',
      summary: {
        total: 0,
        present: 0,
        late: 0,
        absent: 0,
        early: 0,
        incomplete: 0,
        off_days: 0
      },
      emptytext: "No records found.",
      employee: {
        name: "",
        employee_code: "",
        pic: ""
      },
      minDate: '',
      maxDate:'',
      fdata: {
        id: null,
        leave_deduct: 0,
        salary_deduct: 0,
        amount: 0,
        p_leave_deduct: 0,
        p_salary_deduct: 0,
        p_amount: 0
      },
      year: new Date().getFullYear(),
      month: String(new Date().getMonth() + 1).padStart(2, "0"),
      monthOptions: [
        { value: 1, text: "January" },
        { value: 2, text: "February" },
        { value: 3, text: "March" },
        { value: 4, text: "April" },
        { value: 5, text: "May" },
        { value: 6, text: "June" },
        { value: 7, text: "July" },
        { value: 8, text: "August" },
        { value: 9, text: "September" },
        { value: 10, text: "October" },
        { value: 11, text: "November" },
        { value: 12, text: "December" }
      ],
      yearOptions: [],
      penaltyFields: [
        { key: "employee_code", label: "Employee Code" },
        { key: "name", label: "Employee Name" },
        { key: "attendance_from", label: "From" },
        { key: "attendance_to", label: "To" },
        { key: "amount", label: "Deduction Days" },
        { key: "leave_deduct", label: "Leave Deduct" },
        { key: "leave_type", label: "Leave Category" },
        { key: "salary_deduct", label: "Salary Deduct (Days)" },
        { key: "status", label: "Status" }
      ]
    };
  },

  computed: {
    finalizedPenalties() {
      return (this.penalties || []).filter(r => Number(r.status) !== 2);
    },

    penaltiesAggregate() {
      const rows = this.finalizedPenalties;
      let amount = 0;
      let leave = 0;
      let salary = 0;
      const employeeSet = new Set();

      rows.forEach(r => {
        amount += Number(r.amount) || 0;
        leave += Number(r.leave_deduct) || 0;
        salary += Number(r.salary_deduct) || 0;

        if (r.employee_id != null) {
          employeeSet.add(r.employee_id);
        }
      });

      return {
        employees: employeeSet.size,
        entries: rows.length,
        amount: amount.toFixed(2),
        leave_deduct: leave.toFixed(2),
        salary_deduct: salary.toFixed(2),
      };
    },

    isFutureMonth() {
      const today = new Date();
      const cy = today.getFullYear();
      const cm = today.getMonth() + 1;
      const y = Number(this.year);
      const m = Number(this.month);

      if (!y || !m) return false;
      if (y > cy) return true;
      if (y === cy && m > cm) return true;

      return false;
    },
  },

  methods: {
    moveBack: function(){
        this.$refs.wizard.prevTab();
    },
    changeMessageflagBefore: function(){
        let nav_wrapper = document.querySelector('.wizard-nav-pills');
        if(nav_wrapper){
            let nav_active = nav_wrapper.querySelector('li.active');
            let wizard_icon_circle = nav_active.querySelector('.wizard-icon-circle');
            //alert(wizard_icon_circle.classList);
            wizard_icon_circle.classList.add('activated');
        }
        this.show_final_message='';
        this.success='';
        return true;
    },

    formatDeductNumber(value) {
      const num = Number(value || 0);

      if (Number.isInteger(num)) {
        return String(num);
      }

      return num.toFixed(1);
    },
    togglePenaltySummary(row) {
      const key = row.id;
      this.$set(
          this.expandedPenaltyRows,
          key,
          !this.expandedPenaltyRows[key]
      );
      if (this.expandedPenaltyRows[key]) {
        this.loadPenaltySummary(row);
      }
    },

    loadPenaltySummary(row) {
      if (this.penaltySummaryMap[row.id]) {
        return;
      }

      axios.get(this.$api_url + "/leave-attendance/penalty/summary/" + row.id).then(response => {
          this.$set(
              this.penaltySummaryMap,
              row.id,
              response.data.summary || this.emptyPenaltySummary()
          );
        }).catch(error => {
          this.serverError(error);
        });
    },

    emptyPenaltySummary() {
      return {
        total_penalty_rows: 0,
        absent_count: 0,
        late_count: 0,
        early_count: 0,
        incomplete_count: 0,
        incomplete_minutes: 0,
        incomplete_hours: 0,
      };
    },

    getPenaltySummary(row) {
      return this.penaltySummaryMap[row.id] || this.emptyPenaltySummary();
    },

    isPenaltySummaryOpen(row) {
      return !!this.expandedPenaltyRows[row.id];
    },
    viewPenalty(data) {
      this.penaltyDetails = [];
      this.selectedDetailIds = [];
      this.selectAllDetails = false;
      this.employee = {
        name: "",
        employee_code: "",
        pic: ""
      };
      this.selectedPenaltyId = data.id;
      this.selectedPenaltyRow = data;

      let formData = new FormData();
      formData.append("employee_id", data.employee_id);

      this.loading = true;

      axios.post(this.$api_url + "/employee/setemployee", formData).then(() => {
        this.$bvModal.show("penalty-details-modal");
        this.loading = false;
      });
    },
    buildRequestFormData() {
      const formData = new FormData();
      formData.append("year", this.year);
      formData.append("month", this.month);
      formData.append("date_range_mode", this.date_range_mode);
      formData.append("range_from_date", this.range_from_date || "");
      formData.append("range_to_date", this.range_to_date || "");
      return formData;
    },

    getCompanyLeaveSettings:function()
    {
      if(!this.checkNet()) return false;
      axios.get(this.$api_url+'/leave-attendance/company/leave/settings', {
        params: {
          month: this.month,
        }
      }).then(function(response){

        if(response.data.length != 0)
        {
          this.minDate = response.data.range.penalty[0];
          this.maxDate = response.data.range.penalty[1];
        }

      }.bind(this));

    },
    viewSummary() {
      if (this.penalties.length == 0) {
        this.$bvToast.toast("No penalties to summarize.", {
          title: "Warning",
          variant: "warning",
          solid: true
        });
        return;
      }

      this.maxUnlockedStep = 3;
      this.goToWizardStep(3);
    },
    validateDate() {
      if (this.isFutureMonth) {
        this.$bvToast.toast("Future month can't be accessed!", {
          title: "Warning",
          variant: "danger",
          solid: true
        });
      }
    },

    onComplete() {
      this.$bvToast.toast("Penalty flow completed.", {
        variant: "success",
        title: "Done",
        solid: true
      });
    },

    buildYearOptions() {
      let currentYear = new Date().getFullYear();
      let startYear = currentYear - 5;
      let endYear = currentYear + 2;
      let arr = [];

      for (let i = startYear; i <= endYear; i++) {
        arr.push({
          value: i,
          text: String(i)
        });
      }

      this.yearOptions = arr;
    },

    getWizard() {
      return this.$refs.wizard;
    },

    async nextWizardStep() {
      let wizard = this.getWizard();

      if (!wizard) {
        return;
      }

      let currentIndex = wizard.activeTabIndex;
      let go = true;

      try {
        if (currentIndex === 0) {
        go = await this.beforeChangeStep1();
        } else if (currentIndex === 1) {
        go = await this.beforeChangeStep3();   // date range validation
        }

        if (!go) {
          return;
        }

        this.maxUnlockedStep = Math.max(this.maxUnlockedStep, currentIndex + 1);

        if (typeof wizard.nextTab === "function") {
          wizard.nextTab();
        }
      } catch (e) {
        this.serverError(e);
      }
    },

    goToWizardStep(index) {
      let wizard = this.getWizard();

      if (!wizard) {
        return;
      }

      if (typeof wizard.changeTab == "function") {
        let currentIndex = wizard.activeTabIndex;
        wizard.changeTab(currentIndex, index);
        return;
      }

      if (typeof wizard.navigateToTab == "function") {
        wizard.navigateToTab(index);
      }
    },

    async beforeChangeStep1() {
      try {
        this.loading = true;

        this.getCompanyLeaveSettings();
        const response = await axios.get(this.$api_url + "/leave-attendance/penalty-runs/check-month-status", {
          params: { month: this.month, year: this.year }
        });
        this.loading = false;

        if (response.data.approved) {
          this.$bvToast.toast("An approved penalty run already exists for this month. You cannot create another one.", {
            title: "Warning",
            variant: "danger",
            solid: true
          });
          return false;
        }

        if (!response.data.has_data) {
          this.$bvToast.toast("No attendance data found for the selected month. Nothing to generate.", {
            title: "No Data",
            variant: "danger",
            solid: true
          });
          return false;
        }

        return true;
      } catch (e) {
        return true;
      }
    },

    beforeChangeStep3() {
      if (!this.date_range_mode) {
        return true;
      }

      if (!this.range_from_date || !this.range_to_date) {
        this.$bvToast.toast("Please select both from date and to date.", {
          title: "Warning",
          variant: "warning",
          solid: true
        });
        return false;
      }

      if (this.range_from_date > this.range_to_date) {
        this.$bvToast.toast("From date cannot be greater than to date.", {
          title: "Warning",
          variant: "warning",
          solid: true
        });
        return false;
      }

      return true;
    },

    handleWizardChange(prevIndex, nextIndex) {
      if (nextIndex > this.maxUnlockedStep) {
        this.$nextTick(() => {
          let wizard = this.getWizard();

          if (wizard && typeof wizard.changeTab === "function") {
            wizard.changeTab(nextIndex, this.maxUnlockedStep);
          }
        });

        return;
      }

      if (nextIndex < prevIndex) {
        this.resetStepsAfter(nextIndex);
      }

      this.currentStep = nextIndex;
    },

    resetStepsAfter(step) {
        if (step <= 0) {
            this.selected_run_action = "";
        }
        if (step <= 1) {
            this.date_range_mode = 0;
            this.range_from_date = "";
            this.range_to_date = "";
            this.penalties = [];
            this.selectedPenaltyIds = [];
            this.selectAllPenalties = false;
            this.emptytext = "No records found.";
        }
        if (step <= 2) {
            this.penaltyDetails = [];
            this.selectedPenaltyId = null;
            this.selectedPenaltyRow = null;
            this.employee = { name: "", employee_code: "", pic: "" };
        }
        this.maxUnlockedStep = Math.max(1, step);
    },

    resetForm() {
      this.fdata = {
        id: null,
        leave_deduct: 0,
        salary_deduct: 0,
        amount: 0,
        p_leave_deduct: 0,
        p_salary_deduct: 0,
        p_amount: 0
      };
    },

    async previewReport() {
      const formData = this.buildRequestFormData();

      this.loading = true;

      try {
        const response = await axios.post(this.$api_url + "/leave-attendance/penalty/preview", formData);

        this.penalties = response.data || [];
        this.selectedPenaltyIds = [];
        this.selectAllPenalties = false;

        if (this.penalties.length === 0) {
          this.emptytext = "No records found.";
          this.$bvToast.toast("Generate Penalty first to Preview Existing Report", {
            title: "No Existing Report",
            variant: "warning",
            solid: true
          });
          return;
        }

        this.emptytext = "";
        this.maxUnlockedStep = 2;
        this.goToWizardStep(2);
      } catch (e) {
        if (e.response && e.response.status === 422 && e.response.data && e.response.data.message) {
          this.$bvToast.toast(e.response.data.message, {
            title: "No Existing Report",
            variant: "warning",
            solid: true
          });
        } else {
          this.serverError(e);
        }
      } finally {
        this.loading = false;
      }
    },

    async generatePenalty() {
      const formData = this.buildRequestFormData();

      this.loading = true;

      this.$bvToast.toast("We are generating penalty report for selected month", {
        variant: "success",
        title: "Processing",
        solid: true
      });

      try {
        let res = await axios.post(this.$api_url + "/leave-attendance/penalty/generate", formData);
        if(res.data.errors) {
          this.errors = res.data.errors;
          return;
        }
        this.errors = [];

        const response = await axios.post(this.$api_url + "/leave-attendance/penalty/preview", formData);

        this.penalties = response.data || [];
        this.selectedPenaltyIds = [];
        this.selectAllPenalties = false;

        if (this.penalties.length === 0) {
          this.emptytext = "No records found.";
        } else {
          this.emptytext = "";
        }

        this.changeMessageflagBefore();
        this.maxUnlockedStep = 2;
        this.goToWizardStep(2);
      } catch (e) {
        this.handlePenaltyError(e, "Generate Failed");
      } finally {
        this.loading = false;
      }
    },

    handlePenaltyError(e, title) {
      if (e.response && e.response.status === 422 && e.response.data && e.response.data.message) {
        this.$bvToast.toast(e.response.data.message, {
          title: title,
          variant: "warning",
          solid: true
        });
      } else {
        this.serverError(e);
      }

      this.loading = false;
    },


    graceAll() {
      for (let i = 0; i < this.penaltyDetails.length; i++) {
        this.$set(this.penaltyDetails[i], "grace", 1);
      }
    },

    markAsGrace(id) {
      const index = this.penaltyDetails.findIndex(item => item.id == id);

      if (index == -1) {
        return;
      }

      this.$set(this.penaltyDetails[index], "grace", 1);
    },

    unmarkAsGrace(id) {
      const index = this.penaltyDetails.findIndex(item => item.id == id);

      if (index == -1) {
        return;
      }

      this.$set(this.penaltyDetails[index], "grace", 0);
    },

    toggleAllDetails(checked) {
      if (checked) {
        this.selectedDetailIds = this.penaltyDetails.map(item => item.id);
      } else {
        this.selectedDetailIds = [];
      }
    },

    syncSelectAllDetails() {
      this.selectAllDetails = this.penaltyDetails.length > 0
          && this.selectedDetailIds.length == this.penaltyDetails.length;
    },


    settlePenalty(status) {
      this.$bvModal.hide("settle-modal-penalty");
      this.$bvModal.msgBoxConfirm("Are you sure?", {
        title: "Please Confirm",
        size: "sm",
        buttonSize: "sm",
        okVariant: "primary",
        okTitle: "Yes",
        cancelTitle: "Cancel",
        bodyClass: "text-center",
        footerClass: "p-2 border-0 d-flex justify-content-center",
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        if (!value) {
          return;
        }

        if (this.penaltyDetails.length == 0) {
          return;
        }

        try {
          const formData = new FormData();

          const dates = this.penaltyDetails.map(item => {
            return moment(item.date, "YYYY-MM-DD");
          });

          const from = moment.min(dates).format("YYYY-MM-DD");
          const to = moment.max(dates).format("YYYY-MM-DD");

          const penaltyGraceMap = this.penaltyDetails.reduce((acc, item) => {
            acc[item.id] = Number(item.grace);
            return acc;
          }, {});

          const employee_id = this.penaltyDetails[0].employee_id;

          formData.append("from", from);
          formData.append("to", to);
          formData.append("status", status);
          formData.append("employee_id", employee_id);
          formData.append("penalty_id", this.selectedPenaltyId);
          formData.append("penalty_grace", JSON.stringify(penaltyGraceMap));

          this.loading = true;

          axios.post(this.$api_url + "/leave-attendance/penalty/update", formData)
              .then(response => {
                this.$bvToast.toast(response.data.message, {
                  solid: true,
                  title: "Success",
                  variant: "success"
                });

                this.$refs.wizard.nextTab();
                this.loading = false;
              });

        } catch (e) {
          this.serverError(e);
        } finally {
          this.loading = false;
        }
      });
    },


    ignorePenalty(data = null, flag) {
      if (flag == 1 && (!this.selectedPenaltyIds || this.selectedPenaltyIds.length == 0)) {
        this.$bvToast.toast("Select at least one row to ignore.", {
          title: "Warning",
          variant: "warning",
          solid: true
        });
        return;
      }

      this._updatePenaltyStatus(data, flag, 2);
    },

    _updatePenaltyStatus(data, flag, newStatus) {
      const isDraft = newStatus == 1;
      const verb = isDraft ? "Draft" : "Ignore";

      let msg = "";

      if (data != null) {
        msg = verb + " penalty for " + data.name + "?";
      } else {
        msg = verb + " selected penalties?";
      }

      this.$bvModal.msgBoxConfirm(msg, {
        title: "Please Confirm",
        size: "sm",
        okVariant: isDraft ? "success" : "danger",
        okTitle: verb,
        cancelTitle: "Cancel",
        centered: true,
        bodyClass: "text-center",
        footerClass: "p-2 border-0 d-flex justify-content-center",
      }).then(value => {
        if (!value) {
          return;
        }

        try {
          const formData = new FormData();
          formData.append("status", newStatus);

          if (data == null) {
            if (flag == 1) {
              formData.append("all", 0);
              formData.append("penalty_ids", JSON.stringify(this.selectedPenaltyIds));
            } else {
              formData.append("all", 1);
            }
          } else {
            formData.append("penalty_ids", JSON.stringify([data.id]));
          }

          this.loading = true;

          axios.post(this.$api_url + "/leave-attendance/penalty/ignore", formData)
              .then(response => {
                this.$bvToast.toast(response.data.message, {
                  solid: true,
                  title: "Success",
                  variant: "success"
                });

                const reloadFormData = new FormData();
                reloadFormData.append("year", this.year);
                reloadFormData.append("month", this.month);

                axios.post(this.$api_url + "/leave-attendance/penalty/preview", reloadFormData)
                    .then(previewResponse => {
                      this.penalties = previewResponse.data || [];
                      this.selectedPenaltyIds = [];
                      this.selectAllPenalties = false;
                      this.loading = false;
                    })
                    .catch(() => {
                      this.loading = false;
                    });
              })
              .catch(e => {
                this.serverError(e);
                this.loading = false;
              });

        } catch (e) {
          this.serverError(e);
          this.loading = false;
        }
      });
    }
  },

  created() {
    this.buildYearOptions();
  }
};
</script>
